import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@api';
import { QueryKeys } from '@config';

/**
 * Cancels an order by id.
 *
 * Required params: order id passed to mutate/mutateAsync.
 * Preconditions: user must be authenticated and authorized for order cancellation.
 * Important behavior: invalidates ORDERS query cache after success.
 *
 * @example
 * const { mutateAsync } = useCancelOrder();
 * await mutateAsync(orderId);
 */
export const useCancelOrder = (options: object = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (orderID: string) => {
      const response = await apiClient.ordersCancelCreate({
        path: { identifier: orderID },
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.ORDERS],
      });
    },
    ...options,
  });
};
